import { ICod } from './cod.interface';

export interface ICodWithSubtype<T extends { issueType: string }> extends ICod {
    subType: T;
}
